import { FileText, Trash2, Play } from "lucide-react";
import { timeAgo } from "@/lib/api";

export const DraftsCard = ({ drafts, activeId, showName, onResume, onDelete }) => {
  if (!drafts.length) return null;
  return (
    <div className="card-surface rounded-3xl p-5" data-testid="drafts-card">
      <p className="eyebrow mb-3 flex items-center gap-1.5"><FileText size={12} /> Drafts</p>
      <div className="space-y-2">
        {drafts.map((d, i) => (
          <div key={d.id} className={`rounded-xl border p-3 ${d.id === activeId ? "border-sky-400/60 bg-sky-400/10" : "border-white/10 bg-white/[0.03]"}`} data-testid={`draft-${i}`}>
            <p className="text-sm font-semibold truncate" data-testid={`draft-title-${i}`}>{d.title || "Untitled episode"}</p>
            <p className="text-xs text-slate-400 truncate">{showName(d.show_id) || "No show yet"} · saved {timeAgo(d.updated_at)}{d.audio ? " · audio attached" : " · no audio yet"}</p>
            <div className="mt-2 flex items-center gap-2">
              {d.id !== activeId && <button type="button" onClick={() => onResume(d)} className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2.5 py-1 text-[11px] font-bold text-white hover:bg-white/20" data-testid={`draft-resume-${i}`}><Play size={11} /> Resume</button>}
              {d.id === activeId && <span className="rounded-full bg-sky-400 px-2.5 py-1 text-[11px] font-bold text-[#070F1E]">Editing</span>}
              <button type="button" onClick={() => onDelete(d)} className="ml-auto p-1.5 text-slate-400 hover:text-rose-400" aria-label="Delete draft" data-testid={`draft-delete-${i}`}><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
